import * as React from 'react';

import {PlanName} from '../../../pages/Billing/util';
import {ACADEMIC_APPLICATION_PATH} from '../../../routes/onboarding/onboardingPaths';
import {UTM_Content, UTM_Source} from '../../../routes/paths';
import {Analytics} from '../../../services/analytics';
import {useGetSubscriptionPlanByName} from '../../../util/accounts/pricing';
import {usePlanUpsellState} from '../../../util/accounts/usePlanUpsellState';
import {useNavigateTo} from '../../../util/history';
import {useRampFlagAccountSelector} from '../../../util/rampFeatureFlags/rampFeatureFlags';
import {trialEndPage} from '../../../util/urls';
import {SidebarPlanCard} from './SidebarPlanCard';

export const TrialCard = () => {
  const navigateTo = useNavigateTo();
  const enableAccountSelector = useRampFlagAccountSelector();
  const {loading: loadingPlan, plans} = useGetSubscriptionPlanByName();
  const {loading: loadingState, state} = usePlanUpsellState();

  if (loadingPlan || loadingState || !enableAccountSelector || state == null) {
    return null;
  }

  const {daysUntilExpired} = state;

  if (state.kind === 'trial') {
    const downgradePlan = plans[PlanName.CommunityEdition];
    const freePlanText = downgradePlan
      ? `${downgradePlan.displayName} plan`
      : 'free plan';

    if (state.isAcademic) {
      return (
        <SidebarPlanCard
          title={`${state.trialPlanName} trial`}
          description="Complete your application to get access to the Academic plan for free forever."
          daysUntilExpired={daysUntilExpired}
          onClick={() => {
            Analytics.track(`Apply for Academic Clicked`, {
              location: 'Sidebar Trial Card',
              daysUntilExpired,
            });
            navigateTo({pathname: ACADEMIC_APPLICATION_PATH});
          }}
          buttonLabel="Complete application"
        />
      );
    }

    return (
      <SidebarPlanCard
        title={`${state.trialPlanName} trial`}
        description={`At the end of the trial, purchase a plan or downgrade to the ${freePlanText}`}
        daysUntilExpired={daysUntilExpired}
        onClick={() => {
          Analytics.track(`Choose Plan Clicked`, {
            location: 'Sidebar Trial Card',
            daysUntilExpired,
          });
          navigateTo({pathname: trialEndPage()});
        }}
        buttonLabel={
          daysUntilExpired == null || daysUntilExpired > 0
            ? 'Manage plan'
            : 'Choose plan'
        }
      />
    );
  }

  const planName = plans[PlanName.CommunityEdition]?.displayName ?? 'Free';
  return (
    <SidebarPlanCard
      title={`${planName} plan`}
      description="Upgrade for premium features or apply for an academic scholarship"
      daysUntilExpired={daysUntilExpired}
      onClick={() => {
        Analytics.track(`Choose Plan Clicked`, {
          location: 'Sidebar Trial Card',
          daysUntilExpired,
        });
        navigateTo({
          location: {
            pathname: trialEndPage(),
            search: `?utm_source=${UTM_Source.FREE_PLAN}&utm_content=${UTM_Content.LEFT_NAV}`,
          },
        });
      }}
      buttonLabel="View plans"
    />
  );
};
